"use client";

import { ComponentProps } from "react";
import { useIsShopsite } from "@context/DomainContext";
import { TextArea as RadixTextArea } from "@radix-ui/themes";
import { PropsWithChildren } from "react";
import { joinClassNames } from "@utils/helpers";

interface Props {
  shopsiteClasses?: string;
  whitelabelClasses?: string;
  sharedClasses?: string;
}

export default function TextArea({
  className = "",
  shopsiteClasses = "",
  whitelabelClasses = "",
  sharedClasses = "",
  ref,
  ...restProps
}: ComponentProps<typeof RadixTextArea> & PropsWithChildren<Props>) {
  const isShopsite = useIsShopsite();

  const shopsiteBaseClasses =
    "rounded-md border border-gray-300 px-2 py-1.5 text-black focus:outline-none focus:border-2 focus:py-[5px] focus:px-[7px] focus:border-indigo-500 disabled:text-gray-600 disabled:bg-gray-200 transition-colors duration-100 ease-in-out";

  if (isShopsite) {
    return (
      <textarea
        ref={ref}
        className={joinClassNames(
          shopsiteBaseClasses,
          className,
          sharedClasses,
          shopsiteClasses
        )}
        {...restProps}
      />
    );
  }

  return (
    <RadixTextArea
      ref={ref}
      className={joinClassNames(
        isShopsite ? shopsiteBaseClasses : "",
        className,
        sharedClasses,
        isShopsite ? shopsiteClasses : whitelabelClasses
      )}
      {...restProps}
    />
  );
}
